import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SharedDataService } from '../../shared-data.service';
import { SharedService } from '../../shared.service';
import { WebhookDefData } from '../../models/sharedModel';
import { WebhookCusotmFieldsAllowed } from '../../sharedModel';
import { errorMsgs, RegExPatterns, WebhookFieldTypesList } from 'src/app/constants';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-web-hook-custom-fields',
  templateUrl: './web-hook-custom-fields.component.html',
  styleUrls: ['./web-hook-custom-fields.component.scss']
})
export class WebHookCustomFieldsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() fromComponent: string;

  @Input() sectionName: string;

  @Input() webhookDefData: WebhookDefData | undefined;

  @Input() columClass: string;

  @Output() customFieldsFormChange = new EventEmitter();

  @ViewChild('customFieldsForm', { static: true }) public customFieldsForm: NgForm;

  idString = '';

  customFieldsFormSubscriber: any;

  errorMsgs = errorMsgs;

  destroySubscription = false;

  regExPatterns = RegExPatterns;

  constructor(private sharedService: SharedService, private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    if (!this.columClass) {
      this.columClass = 'col-lg-6'
    }
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'whform');
    this.customFieldsFormSubscriber = this.customFieldsForm.form.valueChanges.subscribe(x => {
      const tempObj = {
        formData: this.customFieldsForm
      }
      this.customFieldsFormChange.emit(tempObj);
    });
  }

  isValidJson(jsonString: any) {
    // console.log(jsonString);
    if (typeof this.webhookDefData?.custom_fields_refactored !== 'string') {
      return true;
    }
    try {
      JSON.parse(jsonString);
      return true; // If parsing succeeds, it's valid JSON
    } catch (e) {
      return false; // If an error occurs during parsing, it's not valid JSON
    }
  }

  allowedFields(field: WebhookCusotmFieldsAllowed) {
    return (field.fieldLabel && field.fieldType && WebhookFieldTypesList.find(type => field.fieldType === type))
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes', changes);
    // if (changes['webhookDefData']) {
    //   if (this.webhookDefData?.custom_fields_refactored && this.webhookDefData.custom_fields_refactored.length) {
    //     this.webhookDefData.custom_fields_refactored.forEach((field: any) => {
    //       if (!field.fieldType) {
    //         field.fieldType = 'text';
    //       }
    //       if (field.fieldType === 'dropdown') {
    //         field.value = field?.fieldOptions?.values[0]?.option ? field?.fieldOptions?.values[0]?.option : '';
    //       }
    //     });
    //   }
    // }
  }

  ngOnDestroy(): void {
    if (this.customFieldsFormSubscriber) {
      this.customFieldsFormSubscriber.unsubscribe();
    }
    this.destroySubscription = true;
  }

}
